import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import Slider from 'react-slick';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';

import SliderLeftHovered from '../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../images/right-black-arrow-3.png';
import ArrowBlackRight from '../../../images/arrow-black-right.png';
import ArrowBlackLeft from '../../../images/arrow-black-left.png';

// Redux
import {
  getPopularBrands,
  getCollectionList,
} from '../../../actions/kafairAction';
import { getCloudImageUrl } from '../../../utils/Helpers';

type PreviousSlider = {
  className: string;
  style: Object;
  onClick: () => any;
};

const PrevSlide: FC<PreviousSlider> = (props) => {
  const { className, style, onClick } = props;
  const [hovered, setHovered] = useState(false);

  function hover() {
    setHovered(!hovered);
  }

  const LeftArrow = styled.div`
    left: -50px !important;
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        width: '40px',
        height: '40px',
        left: '-50px !important',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={hover}
      onMouseLeave={hover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

type NextSlider = {
  className: string;
  style: Object;
  onClick: () => any;
};

const NextSlide: FC<NextSlider> = (props) => {
  const { className, style, onClick } = props;
  const [hovered, setHovered] = useState(false);

  function hover() {
    setHovered(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: 0px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 ? 'none' : 'block',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={hover}
      onMouseLeave={hover}
    >
      <KickImage src={hovered ? ArrowBlackRight : SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

interface HistoryInterface {
  push(args: string): any;
  replace(args: string): any;
}

interface Orientation {
  orientation: string;
}

type PopularBrands = {
  getPopularBrands(args: Object): any;
  history: HistoryInterface;
  category: string;
  getCollectionList: any;
};

const PopularBrands: FC<PopularBrands> = ({
  getPopularBrands,
  history,
  category,
  getCollectionList,
}) => {
  const categoryUrl =
    category === 'apparels'
      ? 'apparel'
      : category === 'lifestyles'
      ? 'electronics-collectibles'
      : category === 'handbags'
      ? 'luxury'
      : category;

  const [hoverId, setHoverId] = useState(0);
  const [settings, setSettings] = useState({});
  const [brandIds, setBrandIds] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (category == 'madeindonesia') {
      let payload = {
        availables: true,
        per_page: 11,
        page: 1,
      };
      getCollectionList('all', 'madeindonesia', payload, 'madeindonesia')
        .then(({ value }) => setData(value.data.brands.data))
        .catch((_) => null);
    } else {
      getPopularBrands({ category })
        .then(({ value }) => setData(value.data))
        .catch((_) => null);
    }
  }, []);

  useEffect(() => {
    setSettings({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      swipe: true,
      prevArrow: <PrevSlide />,
      nextArrow: <NextSlide />,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    let ids = data.map((item) => item.slug);

    setBrandIds(ids);
  }, [data]);

  function handleOnClick(item: any) {
    history.push(`${categoryUrl}/${item?.slug}`);
  }

  function onHoverBrand(item: any) {
    setHoverId(item.id);
  }

  if (window.screen.availWidth < 480) {
    return (
      <div className="popular-brands__Mobile">
        <div className="popular-header__Mobile">
          <h4>Popular Brands</h4>
        </div>
        <div className="popular-main__Mobile">
          {data &&
            data.map((item, index) => {
              if (!item.img_url) return null;
              return (
                <div
                  onClick={() => handleOnClick(item)}
                  className="popular-slide__Mobile"
                  style={{ marginLeft: index === 0 ? '20px' : '12px' }}
                  key={item}
                >
                  <KickImage
                    src={
                      item.img_url &&
                      item.img_url.indexOf('s3.amazonaws.com' > 0)
                        ? getCloudImageUrl(item.img_url, 600)
                        : null
                    }
                    alt={item.img_url}
                  />
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  if (window.screen.availWidth > 480 && data.length < 5) {
    return (
      <div className="popular-brands-section">
        <div className="popular-brands-slides">
          <div className="popular-brands-title">
            <h6>Popular Brands</h6>
            <p className="view-all">
              {brandIds && categoryUrl && (
                <Link
                  to={`/search/${categoryUrl}?brands=${brandIds}`}
                  target="_blank"
                >
                  View All
                </Link>
              )}
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 'auto',
            }}
          >
            {data &&
              data.map((item, index) => {
                if (!item.img_url) return null;
                return (
                  <div
                    onMouseEnter={() => onHoverBrand(item)}
                    onMouseLeave={() => onHoverBrand(0)}
                    onClick={() => handleOnClick(item)}
                    // style={{
                    //   background: `url(${
                    //     item.img_url ? getCloudImageUrl(item.img_url, 600) : ''
                    //   })`,
                    //   backgroundSize: 'cover',
                    //   backgroundPosition: 'center',
                    // }}
                    style={{
                      background: `url(${
                        item.img_url ? getCloudImageUrl(item.img_url, 600) : ''
                      })`,

                      backgroundSize: '100px 100px',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                    className="popular-brands-item"
                  ></div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="popular-brands-section">
      <div className="popular-brands-slides">
        <div className="popular-brands-title">
          <h6>Popular Brands</h6>
          <p style={{ marginBottom: '0.5rem' }} className="view-all">
            {brandIds && categoryUrl && (
              <Link
                to={`/search/${categoryUrl}?brands=${brandIds}`}
                target="_blank"
              >
                View All
              </Link>
            )}
          </p>
        </div>
        <Slider {...settings}>
          {data &&
            data.map((item, index) => {
              const imageLandscape = item.images.filter(
                (img) => img.orientation === 'landscape',
              );
              if (!item.img_url) return null;
              return (
                <div>
                  <div
                    onMouseEnter={() => onHoverBrand(item)}
                    onMouseLeave={() => onHoverBrand(0)}
                    onClick={() => handleOnClick(item)}
                    style={{
                      background: `url(${
                        item.img_url ? getCloudImageUrl(item.img_url, 600) : ''
                      })`,

                      backgroundSize: '100px 100px',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                    className="popular-brands-slide"
                  ></div>
                </div>
              );
            })}
        </Slider>
      </div>
    </div>
  );
};
interface PopularBrandsData {
  popularBrands: any;
}
interface CategoryBrand {
  categoryBrand: PopularBrandsData;
}
interface State {
  dataKaFair: CategoryBrand;
}

const mapDispatchToProps = (dispatch: any) => ({
  getPopularBrands: (query: Object) => dispatch(getPopularBrands(query)),
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(null, mapDispatchToProps)(PopularBrands);
